import type { Dayjs } from "dayjs";

import { djs } from "@/lib/djs";

import { OPERATION_ZONE } from "./shared";

const weekdayName: Record<number, string> = {
	0: "domingo",
	1: "segunda",
	2: "terça",
	3: "quarta",
	4: "quinta",
	5: "sexta",
	6: "sábado",
};

function clock(moment: Dayjs) {
	if (moment.minute() === 0) {
		return `${moment.hour()}h`;
	}

	return `${moment.hour()}h${String(moment.minute()).padStart(2, "0")}`;
}

function moment(iso: Date | string) {
	const at = djs(iso).tz(OPERATION_ZONE);

	const now = djs().tz(OPERATION_ZONE);

	const days = now.startOf("day").diff(at.startOf("day"), "day");

	if (days <= 0) {
		return `hoje ${clock(at)}`;
	}

	if (days === 1) {
		return `ontem ${clock(at)}`;
	}

	if (days < 7) {
		return `${weekdayName[at.day()]} ${clock(at)}`;
	}

	return `${at.format("DD/MM")} às ${clock(at)}`;
}

export const OperacaoLabels = {
	moment,

	since(iso: Date | string | null) {
		if (iso === null) {
			return "sem registro ainda";
		}

		return `desde ${moment(iso)}`;
	},

	lastAt(iso: Date | string | null) {
		if (iso === null) {
			return "sem registro ainda";
		}

		return moment(iso);
	},
};
